<template>
  <div>
    <kst-input field="DiscType" :data="userData" :catalog="Catalog"
      :options="discTypeOptions" @input="handleDiscType_input"
    >
      <template #right>
        <template v-if="userData.DiscType === Model.DiscType.Value.ID">
          <kst-input addons expanded floating-label
            field="DiscValue" :data="userData" :catalog="Catalog"
            @input="handleDiscValue_input"
          />
        </template>
        <template v-else-if="userData.DiscType === Model.DiscType.Percent.ID">
          <kst-input addons expanded floating-label
            field="DiscPercent" :data="userData" :catalog="Catalog"
            @input="handleDiscPercent_input"
          />
        </template>
        <template v-else>
          <div class="field control is-expanded">
            <input class="input is-invisible"/>
          </div>
        </template>
      </template>
    </kst-input>

    <kst-input field="Comment" :data="userData" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../InvCatalog.js";
import Model from "../InvModel.js";

export default {
  props: {
    userData: Object,
    userItems: Array
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model
  }),
  computed: {
    discTypeOptions() {
      return Model.createDiscTypeOptions();
    }
  },
  methods: {
    handleDiscType_input() {
      Model.updateDetails(this.userData, this.userItems);
      Model.normalizeDetailsByDisc(this.userData);
    },
    handleDiscValue_input() {
      Model.updateDetails(this.userData, this.userItems);
    },
    handleDiscPercent_input() {
      Model.updateDetails(this.userData, this.userItems);
    }
  }
}
</script>